//if (!customElements.get("pickup-availability")) {
//	customElements.define(
//		"pickup-availability",
//		class PickupAvailability extends HTMLElement {
//			constructor() {
//				super();

//				if (!this.hasAttribute("available")) return;

//				this.errorHtml =
//					this.querySelector("template").content.firstElementChild.cloneNode(
//						true
//					);
//				this.onClickRefreshList = this.onClickRefreshList.bind(this);
//				this.fetchAvailability(this.dataset.variantId);
//			}

//			fetchAvailability(variantId) {
//				const variantSectionUrl = `${this.dataset.baseUrl}variants/${variantId}/?section_id=pickup-availability`;

//				fetch(variantSectionUrl)
//					.then((response) => response.text())
//					.then((text) => {
//						const sectionInnerHTML = new DOMParser()
//							.parseFromString(text, "text/html")
//							.querySelector(".shopify-section");
//						this.renderPreview(sectionInnerHTML);
//					})
//					.catch((e) => {
//						this.querySelector("button")?.removeEventListener(
//							"click",
//							this.onClickRefreshList
//						);
//						this.renderError();
//					});
//			}

//			onClickRefreshList(evt) {
//				this.fetchAvailability(this.dataset.variantId);
//			}

//			renderError() {
//				this.innerHTML = "";
//				this.appendChild(this.errorHtml);

//				this.querySelector("button").addEventListener(
//					"click",
//					this.onClickRefreshList
//				);
//			}

//			renderPreview(sectionInnerHTML) {
//				const drawer = document.querySelector("pickup-availability-drawer");
//				if (drawer) drawer.remove();
//				if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
//					this.innerHTML = "";
//					this.removeAttribute("available");
//					return;
//				}

//				this.innerHTML = sectionInnerHTML.querySelector(
//					"pickup-availability-preview"
//				).outerHTML;
//				this.setAttribute("available", "");

//				document.body.appendChild(
//					sectionInnerHTML.querySelector("pickup-availability-drawer")
//				);

//				this.querySelector("button").addEventListener("click", (evt) => {
//					document.querySelector("pickup-availability-drawer").show(evt.target);
//				});
//			}
//		}
//	);
//}

//if (!customElements.get("pickup-availability-drawer")) {
//	customElements.define(
//		"pickup-availability-drawer",
//		class PickupAvailabilityDrawer extends HTMLElement {
//			constructor() {
//				super();

//				this.onBodyClick = this.handleBodyClick.bind(this);

//				this.querySelector("button").addEventListener("click", () => {
//					this.hide();
//				});

//				this.addEventListener("keyup", () => {
//					if (event.code.toUpperCase() === "ESCAPE") this.hide();
//				});
//			}

//			handleBodyClick(evt) {
//				const target = evt.target;
//				if (
//					target != this &&
//					!target.closest("pickup-availability-drawer") &&
//					target.id != "ShowPickupAvailabilityDrawer"
//				) {
//					this.hide();
//				}
//			}

//			hide() {
//				this.removeAttribute("open");
//				document.body.removeEventListener("click", this.onBodyClick);
//				document.body.classList.remove("overflow-hidden");
//				removeTrapFocus(this.focusElement);
//				document.querySelector(
//					".pickup-availability-overlay"
//				).style.visibility = "hidden";
//			}

//			show(focusElement) {
//				this.focusElement = focusElement;
//				this.setAttribute("open", "");
//				document.body.addEventListener("click", this.onBodyClick);
//				document.body.classList.add("overflow-hidden");
//				trapFocus(this);
//				document.querySelector(
//					".pickup-availability-overlay"
//				).style.visibility = "visible";
//			}
//		}
//	);
//}
if (!customElements.get("pickup-availability")) {
	customElements.define(
		"pickup-availability",
		class PickupAvailability extends HTMLElement {
			constructor() {
				super();

				if (!this.hasAttribute("available")) return;

				this.errorHtml =
					this.querySelector("template").content.firstElementChild.cloneNode(
						true
					);
				this.onClickRefreshList = this.onClickRefreshList.bind(this);
				this.fetchAvailability(this.dataset.variantId);
			}

			fetchAvailability(variantId) {
				const variantSectionUrl = `${this.dataset.baseUrl}variants/${variantId}/?section_id=pickup-availability`;

				fetch(variantSectionUrl)
					.then((response) => response.text())
					.then((text) => {
						const sectionInnerHTML = new DOMParser()
							.parseFromString(text, "text/html")
							.querySelector(".shopify-section");
						this.renderPreview(sectionInnerHTML);
					})
					.catch((e) => {
						this.querySelector("button")?.removeEventListener(
							"click",
							this.onClickRefreshList
						);
						this.renderError();
					});
			}

			onClickRefreshList(evt) {
				this.fetchAvailability(this.dataset.variantId);
			}

			renderError() {
				this.innerHTML = "";
				this.appendChild(this.errorHtml);

				this.querySelector("button").addEventListener(
					"click",
					this.onClickRefreshList
				);
			}

			renderPreview(sectionInnerHTML) {
				const drawer = document.querySelector("pickup-availability-drawer");
				if (drawer) drawer.remove();
				if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
					this.innerHTML = "";
					this.removeAttribute("available");
					return;
				}

				this.innerHTML = sectionInnerHTML.querySelector(
					"pickup-availability-preview"
				).outerHTML;
				this.setAttribute("available", "");

				document.body.appendChild(
					sectionInnerHTML.querySelector("pickup-availability-drawer")
				);

				this.querySelector("button").addEventListener("click", (evt) => {
					document.querySelector("pickup-availability-drawer").show(evt.target);
				});

				// Wire per-location bell toggles after drawer is in DOM
				try {
					var list = document.querySelectorAll('.pickup-availability-list__item[data-location-id]');
					list.forEach(function(item){
						var locationId = item.getAttribute('data-location-id');
						var shopId = item.getAttribute('data-shop-id');
						var toggle = item.querySelector('.bis-location-toggle');
						var collapsible = item.querySelector('#bis-location-collapsible-' + locationId);
						if (toggle && collapsible) {
							toggle.addEventListener('click', function(){
								var expanded = toggle.getAttribute('aria-expanded') === 'true';
								toggle.setAttribute('aria-expanded', String(!expanded));
								collapsible.hidden = expanded;
							});
						}

						// Wire form submit with validation + fake success
						var form = item.querySelector('#bis-location-form-' + locationId);
						var success = item.querySelector('#bis-location-success-' + locationId);
						var errorEl = item.querySelector('#bis-location-error-' + locationId);
						var infoEl = item.querySelector('#bis-location-info-' + locationId);
						var emailInput = form ? form.querySelector('input[name="email"]') : null;
						var phoneInput = form ? form.querySelector('input[name="phone"]') : null;
						var productIdInput = form ? form.querySelector('input[name="product_id"]') : null;
						if (form && success) {
							form.addEventListener('submit', async function(e){
								e.preventDefault();
								var submitBtn = form.querySelector('button[type="submit"]');
								var emailVal = emailInput ? emailInput.value.trim() : '';
								var phoneVal = phoneInput ? phoneInput.value.trim() : '';
								var emailOk = false;
								var phoneOk = false;
								if (emailInput && emailVal.length > 0) {
									emailOk = emailInput.checkValidity();
								}
								if (phoneInput && phoneVal.length > 0) {
									phoneOk = /^(\\+?47\\s?)?\\d{8}$/.test(phoneVal);
								}
								if (!(emailOk || phoneOk)) {
									if (errorEl) errorEl.style.display = 'block';
									if (emailInput) emailInput.style.borderColor = emailVal && !emailOk ? '#B91E1E' : '#d1d1d1';
									if (phoneInput) phoneInput.style.borderColor = phoneVal && !phoneOk ? '#B91E1E' : '#d1d1d1';
									return;
								}
								if (errorEl) errorEl.style.display = 'none';
								if (emailInput) emailInput.style.borderColor = '#d1d1d1';
								if (phoneInput) phoneInput.style.borderColor = '#d1d1d1';
								if (submitBtn) {
									submitBtn.disabled = true;
									submitBtn.textContent = 'Sender…';
								}
								// Fake API test call
								try {
									var result = null;
									if (typeof subscribeToBackinstock === 'function') {
										result = await subscribeToBackinstock(
											productIdInput ? productIdInput.value : undefined,
											locationId,
											emailVal,
											phoneVal,
											shopId
										);
									}

									if (!result || result.success === false) {
										if (errorEl) {
											errorEl.textContent = (result && result.message) ? result.message : 'Noe gikk galt. Prøv igjen senere.';
											errorEl.style.display = 'block';
										}
										if (submitBtn) {
											submitBtn.disabled = false;
											submitBtn.textContent = 'Varsle meg';
										}
										return;
									}
								} catch (err) {
									if (errorEl) {
										errorEl.textContent = 'Noe gikk galt. Prøv igjen senere.';
										errorEl.style.display = 'block';
									}
									if (submitBtn) {
										submitBtn.disabled = false;
										submitBtn.textContent = 'Varsle meg';
									}
									return;
								}
								try {
									form.style.display = 'none';
									if (infoEl) infoEl.style.display = 'none';
									success.style.display = 'flex';
								} catch(e) {
									if (errorEl) {
										errorEl.textContent = 'Noe gikk galt. Prøv igjen senere.';
										errorEl.style.display = 'block';
									}
									if (submitBtn) {
										submitBtn.disabled = false;
										submitBtn.textContent = 'Varsle meg';
									}
								}
							});
						}
					});
				} catch (e) {}
			}
		}
	);
}

if (!customElements.get("pickup-availability-drawer")) {
	customElements.define(
		"pickup-availability-drawer",
		class PickupAvailabilityDrawer extends HTMLElement {
			constructor() {
				super();

				this.onBodyClick = this.handleBodyClick.bind(this);

				this.querySelector("button").addEventListener("click", () => {
					this.hide();
				});

				this.addEventListener("keyup", (event) => {
					if (event.code.toUpperCase() === "ESCAPE") this.hide();
				});

				const searchInput = this.querySelector('#PickupZipSearch');
				if (searchInput) {
					searchInput.addEventListener('input', (e) => {
						const term = (e.target.value || '').toString().trim();
						this.filterByZip(term);
					});
				}
			}

			handleBodyClick(evt) {
				const target = evt.target;
				if (
					target != this &&
					!target.closest("pickup-availability-drawer") &&
					!evt
						.composedPath()
						.includes(document.getElementById("ShowPickupAvailabilityDrawer"))
				) {
					this.hide();
				}
			}

			filterByZip(term) {
				const normalized = term.replace(/\D/g, "");
				const items = this.querySelectorAll('.pickup-availability-list__item');
				if (!items.length) return;
				if (!normalized) {
					items.forEach((li) => {
						li.style.display = '';
					});
					return;
				}
				items.forEach((li) => {
					const zip = (li.getAttribute('data-zip') || '').replace(/\D/g, "");
					li.style.display = zip.startsWith(normalized) ? '' : 'none';
				});
			}

			hide() {
				this.removeAttribute("open");
				document.body.removeEventListener("click", this.onBodyClick);
				document.body.classList.remove("overflow-hidden");
				removeTrapFocus(this.focusElement);
				document.querySelector(
					".pickup-availability-overlay"
				).style.visibility = "hidden";
			}

			show(focusElement) {
				this.focusElement = focusElement;
				this.setAttribute("open", "");
				document.body.addEventListener("click", this.onBodyClick);
				document.body.classList.add("overflow-hidden");
				trapFocus(this);
				document.querySelector(
					".pickup-availability-overlay"
				).style.visibility = "visible";
			}
		}
	);
}
